import { MathUtils as d, Vector3 as p } from "three";
function f(a, t, i = new p()) {
  const s = Math.cos(t), n = Math.sin(t);
  for (const o of a) {
    const c = o.pos[0], r = o.pos[2];
    o.rot[1] += t * d.RAD2DEG, o.pos[0] = c * s + r * n, o.pos[2] = -c * n + r * s, o.pos = new p(...o.pos).add(i).toArray();
  }
}
export {
  f as TranslateAndRotate
};
//# sourceMappingURL=index34.js.map
